import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

interface DetailRowProps {
  label: string;
  value?: string | React.ReactNode;
  chipLabel?: string;
  chipColor?: 'success' | 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info';
  valueStyle?: React.CSSProperties;
}

function DetailRow({
  label,
  value,
  chipLabel,
  chipColor = 'default',
  valueStyle,
}: DetailRowProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant="body2" color="text.secondary">
        {label}:
      </Typography>
      {chipLabel ? (
        <Chip label={chipLabel} color={chipColor} size="small" />
      ) : (
        <Typography variant="body2" sx={valueStyle}>
          {value}
        </Typography>
      )}
    </Box>
  );
}

export default DetailRow;

